// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"8af1ceea3a84e76b2a48","655":"0c69465e03b680e52cad"}[chunkId] + ".js";
};